// extracted by mini-css-extract-plugin
export default {"serviceItem":"Services_serviceItem__bUScQ","iconBox":"Services_iconBox__oD9sL","title":"Services_title__KZCeT","description":"Services_description__7QKDb"};